var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccPro(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_228_1099)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_228_1099)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_1099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_228_1099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8H8V32H32V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_228_1099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5099 13.85L21.5699 10.42C20.5999 9.86 19.3999 9.86 18.4199 10.42L12.4899 13.85C11.5199 14.41 10.9199 15.45 10.9199 16.58V23.42C10.9199 24.54 11.5199 25.58 12.4899 26.15L18.4299 29.58C19.3999 30.14 20.5999 30.14 21.5799 29.58L27.5199 26.15C28.4899 25.59 29.0899 24.55 29.0899 23.42V16.58C29.0799 15.45 28.4799 14.42 27.5099 13.85ZM19.9999 15.34C21.2899 15.34 22.3299 16.38 22.3299 17.67C22.3299 18.96 21.2899 20 19.9999 20C18.7099 20 17.6699 18.96 17.6699 17.67C17.6699 16.39 18.7099 15.34 19.9999 15.34ZM22.6799 24.66H17.3199C16.5099 24.66 16.0399 23.76 16.4899 23.09C17.1699 22.08 18.4899 21.4 19.9999 21.4C21.5099 21.4 22.8299 22.08 23.5099 23.09C23.9599 23.75 23.4799 24.66 22.6799 24.66Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_228_1099",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_228_1099",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 34.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_1099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccPro);
export default __webpack_public_path__ + "static/media/accPro.02e390d435670001d39216fcffa0c98c.svg";
export { ForwardRef as ReactComponent };